/**
 * SubscriptionRequiredPage — shown when the server returns HTTP 402.
 *
 * Displayed as a full-screen overlay (modal) over the app so the user
 * can still see they're logged in and can sign out or contact support.
 * Once Stripe is wired (Phase 5) the "Subscribe" button will redirect
 * to the Stripe Checkout session.
 */

import React from 'react';
import { theme } from '../theme';
import { useAuth } from '../context/AuthContext';

export default function SubscriptionRequiredPage({ onDismiss }) {
  const { user, signOut } = useAuth();

  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: 'rgba(0,0,0,0.85)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 2000, padding: 24,
    }}>
      <div style={{
        background: theme.surface, border: `1px solid ${theme.border}`,
        borderRadius: 14, width: '100%', maxWidth: 420, padding: '36px 32px',
        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16,
        textAlign: 'center',
      }}>
        {/* Icon */}
        <div style={{
          width: 56, height: 56, borderRadius: '50%',
          background: `${theme.warning}18`,
          border: `2px solid ${theme.warning}44`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 24,
        }}>🔒</div>

        <div>
          <h2 style={{ fontSize: 18, fontWeight: 700, color: theme.text, marginBottom: 8 }}>
            Subscription Required
          </h2>
          <p style={{ fontSize: 14, color: theme.textMuted, lineHeight: 1.6 }}>
            An active subscription is needed to run queries.
            {user?.email && (
              <> Signed in as <strong style={{ color: theme.text }}>{user.email}</strong>.</>
            )}
          </p>
        </div>

        {/* Actions */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, width: '100%', marginTop: 8 }}>
          {/* Subscribe button — will link to Stripe in Phase 5 */}
          <button
            onClick={() => window.location.href = 'mailto:support@fusionquery.com?subject=FusionQuery%20Subscription'}
            style={{
              background: theme.accent, color: '#fff', border: 'none',
              borderRadius: 8, padding: '11px 16px', fontSize: 14, fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Contact us to subscribe
          </button>

          <button onClick={signOut} style={{
            background: 'none', border: `1px solid ${theme.border}`,
            borderRadius: 8, padding: '9px 16px', fontSize: 13,
            color: theme.textMuted, cursor: 'pointer',
          }}>
            Sign out
          </button>
        </div>

        <p style={{ fontSize: 12, color: theme.textMuted, marginTop: 4 }}>
          Already subscribed? Contact{' '}
          <a href="mailto:support@fusionquery.com" style={{ color: theme.accent }}>
            support@fusionquery.com
          </a>
        </p>
      </div>
    </div>
  );
}
